import { Fragment, type ReactNode, useSyncExternalStore } from 'react';

import { authSessionGeneration } from '@/features/auth/auth-session';

export const AuthSessionScope = ({ children }: { children: ReactNode }) => {
  const generation = useSyncExternalStore(
    authSessionGeneration.subscribe,
    authSessionGeneration.getSnapshot,
  );

  return <Fragment key={generation}>{children}</Fragment>;
};
